module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"language":"Language"},"ja":{"language":"言語"},"zh-Hant":{"language":"語言"},"zh-Hans":{"language":"语言"}}')
  delete Component.options._Ctor
}
